module.exports = __webpack_public_path__ + "static/media/button_minus_light.02d8cbdb.svg";